import ApiClient from "../../methods/api/apiClient"
import loader from "../../methods/loader";

export const getCheckoutItems = () => {
    return async (dispatch) => {
        try {
            const token = sessionStorage.getItem("token")
            if (token) {
                loader(true)
                const response = await ApiClient.get(`cart/list`)
                if (response.success) {
                    dispatch({ type: "SET_DATA", data: response })
                } else {
                    dispatch({ type: "CLEAR_DATA" })
                }
                loader(false)
            }
        } catch (error) {
            dispatch({ type: "CLEAR_DATA" })
        }
    };
};